import { useCallback, useEffect, useState } from 'react';
import type { PaymentMethod } from '../pages/DashboardPage/views/FinancesView/masters/financeMasters';
import { listPaymentMethods } from '../services/PaymentMethodsService';

// Vías de pago de la sociedad activa, desde la API (payment_methods_list)
export const usePaymentMethods = () => {
  const [methods, setMethods] = useState<PaymentMethod[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const reload = useCallback(async (force = false) => {
    setLoading(true);
    try {
      setMethods(await listPaymentMethods({ force }));
      setError('');
    } catch (err) {
      console.error('Error cargando las formas de pago:', err);
      setError((err as Error)?.message || 'No se pudieron cargar las formas de pago.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    let active = true;
    listPaymentMethods()
      .then(list => { if (active) { setMethods(list); setError(''); } })
      .catch(err => {
        console.error('Error cargando las formas de pago:', err);
        if (active) setError((err as Error)?.message || 'No se pudieron cargar las formas de pago.');
      })
      .then(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);

  return { methods, loading, error, reload };
};
